/**
 * 放置坐标转换相关函数
 */
import { Vector2d } from 'konva/lib/types'
import store from '@ps/store'

/**
 * 转换虚拟场景的坐标到游戏坐标
 * @param position 虚拟舞台的坐标
 */
export function conversionStageToPosition(
  position: Vector2d
): Vector2d {
  const sceneScale: number = store.state.workspace.game.device.scale
  const sceneOffset: Vector2d = store.state.workspace.stage.sceneOffset
  const worldScale = store.state.workspace.game.device.worldScale
  return {
    x: (position.x - sceneOffset.x) / sceneScale / worldScale.x,
    y: (position.y - sceneOffset.y) / sceneScale / worldScale.y
  }
}

/**
 * 转换游戏坐标到虚拟舞台的坐标，注意，该游戏坐标中的坐标值是除了世界坐标缩放值后的值
 * @param position 游戏坐标
 */
export function conversionPositionToStage(
  position: Vector2d
): Vector2d {
  const sceneScale: number = store.state.workspace.game.device.scale
  const sceneOffset: Vector2d = store.state.workspace.stage.sceneOffset
  const worldScale = store.state.workspace.game.device.worldScale
  return {
    x: (position.x * sceneScale * worldScale.x) + sceneOffset.x,
    y: (position.y * sceneScale * worldScale.y) + sceneOffset.y
  }
}
